// extracted by mini-css-extract-plugin
export default {"root":"NoResultsFound_root__7rLIf","reduced":"NoResultsFound_reduced__pcOtt"};